








import {Kunde} from "@/models/kunde-model";
import {Vue, Prop, Component} from "vue-property-decorator";
import Zusatzfunktion from "./Zusatzfunktion.vue";

interface ZF { f: keyof(Kunde), t?: string, x?: string }

@Component({components: {Zusatzfunktion}})
export default class Zusatzfunktionen extends Vue {
    @Prop() kunde!: Kunde;

    get zusatzfunktionen(): ZF[] {
        return [
            ...(this.kunde.IstLizenzKunde ? [] : this.zusatzfunktionen_nur_regulaere_Kunden),
            ...this.zusatzfunktionen_alle_Kunden,
        ];
    }

    private zusatzfunktionen_nur_regulaere_Kunden: ZF[] = [
        {f:'ZusatzfunktionNurBeratung', t:'Kunde.Nur Beratung', x:'Kunde.NurBeratungText'},
        {f:'ZusatzfunktionAbweichenderDatenschutzbeauftragter', t:'Kunde.Abweichender Datenschutzbeauftragter', x:'Kunde.AbweichenderDatenschutzbeauftragterText'},
    ];
    private zusatzfunktionen_alle_Kunden: ZF[] = [
        {f:'ZusatzfunktionDienstleisterKonzerngesellschaft', t:'Kunde.Dienstleister einzelnen Konzerngesellschaften zuordnen', x:'Kunde.DienstleisterKonzerngesellschaftText'},
        {f:'ZusatzfunktionAbteilungKonzerngesellschaft', t:'Kunde.Abteilung einer Konzerngesellschaft zuordnen', x:'Kunde.AbteilungKonzerngesellschaftText'},
        {f:'ZusatzfunktionAuftraggeber', t:'Kunde.Auftraggeber erfassen', x:'Kunde.Auftraggeber erfassen Text'},
        {f:'ZusatzfunktionNutzerBerechtigungAbteilung', t:'Kunde.Nutzer-Berechtigung auf Abteilungen beschränken', x:'Kunde.NutzerBerechtigungAbteilungText'},
        {f:'ZusatzfunktionNutzerBerechtigungKonzerngesellschaft', t:'Kunde.Nutzer-Berechtigung auf Konzerngesellschaften beschränken', x:'Kunde.NutzerBerechtigungKonzerngesellschaftText'},
        {f:'ZusatzfunktionDienstleisterpruefung', t:'Kunde.ZusatzfunktionDienstleisterpruefung', x:'Kunde.ZusatzfunktionDienstleisterpruefungText'},
    ];
}
